(function () {
    "use strict";

    angular.module("app.productDetail").controller("ProductDetailController", ProductDetailController);

    ProductDetailController.$inject = ["$scope", "ProductDetailService","$cookies",'$uibModal','SharedData'];

    function ProductDetailController($scope, ProductDetailService, $cookies, $uibModal, SharedData) {
        /* jshint validthis:true */
        var vm = this;
        var lastProductView = false;
        vm.priceList = [];
        vm.selectedVariant = {};
        vm.SharedData = SharedData;

        function activate() {}

        window.addEventListener(
            "hashchange",
            function () {
                $scope.$apply();
            },
            false
        );

        $scope.$watch(
            function () {
                return location.href;
            },
            function (value) {
                if (value) {
                    var hash = decodeURI(value.split("#")[1]);
                    if (hash) {
                        vm.selectedVariant = vm.priceList.find(function (item) {
                            if(!lastProductView){
                                AddLastViewProductList(item.ProductCode);
                                lastProductView = true;
                            }
                            return item.Code === hash || item.Code === 'main';
                        });     
                                   
                    }
                }
            }
        );
        vm.OpenPhotosModal = function(productId)
        {
            ProductDetailService.getProduct(productId).then(function(data) {
               vm.productImages = data.data.ProductMedia;
               setTimeout(function () {
                    $('.group-product-images .group-product-image').magnificPopup({
                        type: 'image',
                        gallery: {
                            enabled: true
                        }
                    });
                    $($('.group-product-images .group-product-image')[0]).click();
               },100)
            });
        }

        function getCookieByName(name){
            return $cookies.get(name);
        }

        function setCookie(name, value){
            $cookies.put(name,value);
        }

        function AddLastViewProductList(value){
            const unique = (value, index, self) => {
                return self.indexOf(value) === index
              }
            var lastviewProduct = getCookieByName('LastViewProduct');

            var lastViewProductList = [];
            if(lastviewProduct)
                lastViewProductList = lastviewProduct.split(',');
            if(lastViewProductList){
                if(!lastViewProductList.find(x=> x == value)){

                    if(lastViewProductList.length != 5){
                        lastViewProductList.unshift(value);
                    }
                    else{
                        lastViewProductList.shift();
                        lastViewProductList.unshift(value);
                    }
                }
            }
            lastViewProductList = lastViewProductList.filter(unique);
            setCookie('LastViewProduct',lastViewProductList);
        }

        activate();
    }
})();
